<template>
    <div class="textarea">
        <textarea
            ref="input"
            :placeholder="placeholder"
            :value="value"
            :disabled="disabled"
            :required="required"
            @input="$emit('input', $event.target.value)"
        />
    </div>
</template>

<script>
export default {
    props: {
        placeholder: String,
        value: {
            type: String,
            default: '',
        },
        disabled: Boolean,
        required: Boolean,
    },
    methods: {
        focus: function() {
            this.$refs.input.focus();
        },
    },
};
</script>

<style lang="scss">
.textarea {
    // display: block;
    padding: 0;
    margin: 0;
    border: none;

    &.stretch {
        display: flex;

        textarea {
            flex: 1;
        }
    }

    textarea {
        border-radius: 5px;
        padding: 9px 17px;
        border: 1px solid #9ca5b0;
        color: #2a2a2a;
        outline: none;
        transition: all 0.25s ease-in-out;
        font-size: 13px;
        height: 141px;
        width: 488px;

        &:focus {
            border: 1px solid #6c3e91;
        }

        &:disabled {
            background-color: #f8f8f8;
        }
    }

    ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #9ca5b0;
        opacity: 1; /* Firefox */
    }
}
</style>
